<template>
    <div class="tab-wrapper" v-loading="loading">
        <TrackProjects/>
        <TrackEducation/>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TrackEducation from './tab-track/TrackEducation';
import TrackProjects from './tab-track/TrackProjects';

const actions = [
    'loadTrack',
    'loadReportsList',
    'loadAccountEvents',
    'loadAccountProject',
    'loadCompetences',
    'loadProfessions',
    'loadProftest',
    'loadProfessionRecommendations',
];

const getters = [
    'getIsTrackReady',
    'getTrackId',
    'getProftestId',
    'getProfessionRecommendations',
    'getHasGoals',
];

export default {
    name: 'TabTrack',
    components: {
        TrackProjects,
        TrackEducation,
    },
    async created() {
        await this.loadTrack({ view: 'Account' });
        if (this.getIsTrackReady) {
            this.loadProftest();
            this.loadProfessionRecommendations();
        }
        this.loading = false;
    },
    data: () => ({
        loading: true,
    }),
    methods: {
        ...mapActions('accountTrack', actions),
    },
    computed: {
        ...mapGetters('accountTrack', getters),
    },
    async mounted() {
        await this.loadReportsList();
        await this.loadAccountEvents();
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';
@import '../../../styles/mrem';

.tab-wrapper {
    margin-top: rem(16);
    @include on-mobile {
        margin-top: 0;
    }
}

.folder, .folder-last {
    margin-bottom: rem(32);

    @include on-mobile {
        margin-bottom: mrem(24);
    }
}

.folder-last {
    @include on-mobile {
        margin-bottom: 0;
    }
}

.block {
    margin-bottom: rem(40);

    @include on-mobile {
        margin-bottom: mrem(40);
    }

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
